/** All monetary values are stored and transported as integer Egyptian pounds (EGP). Never floats. */
export function formatEgp(amountEgp) {
    return `${amountEgp.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} EGP`;
}
/** Discount maths lives here so checkout preview and server-side charging can never disagree. */
export function applyDiscount(baseEgp, discountType, discountValue) {
    const raw = discountType === 'percent'
        ? Math.round((baseEgp * discountValue) / 100)
        : Math.round(discountValue);
    const discountEgp = Math.max(0, Math.min(raw, baseEgp));
    return {
        baseEgp,
        discountEgp,
        totalEgp: baseEgp - discountEgp,
    };
}
/** Paymob (and similar gateways) expect the smallest currency unit. 1 EGP = 100. */
export function egpToGatewayMinorUnits(amountEgp) {
    return Math.round(amountEgp * 100);
}
//# sourceMappingURL=money.js.map